export const selectAdvertisingState = (state) => state.advertising;

export const selectAdvertising = (state) =>
  state.advertising.advertising;

export const selectAdvertisings = (state) =>
  state.advertising.advertisings;

export const selectAdvertisingsCount = (state) =>
  state.advertising.advertisingsCount;

export const selectAdvertisingsOrderBy = (state) =>
  state.advertising.advertisingsOrderBy;

export const selectAdvertisingsFilter = (state) =>
  state.advertising.advertisingsFilter;

export const selectAdvertisingsPagination = (state) =>
  state.advertising.advertisingsPagination;
